<template>
  <a-alert message="Informational" description="Our Dashboard is Coming Soon" type="info" showIcon />
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MarketingBoard",
  computed: {
    ...mapGetters(["getScreen"])
  }
};
</script>